import { AuthenticatedLayout } from "../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { StatutoryHolidayReport } from "../../../components/Reports/StatutoryHolidayReport";

export const StatutoryHolidayReportPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Statutory Holiday"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
      ]}
      mainContents={<StatutoryHolidayReport/>}
    />
  );
};
